module.exports = __webpack_public_path__ + "static/media/tailwindCss.6987ffb6.svg";